import ThemeOverrideProps from 'ThemeOverrideProps';
import {StyleSheet} from 'react-native';
import {customModalStyles} from './ModalStyles';

const {fontRegular, fontBold, fontExtraBold, textColorCash} = ThemeOverrideProps.sheetStyles;

export const stylesFn = () => {
  return StyleSheet.create({
    title: customModalStyles.modalTitleText,

    subTitle: {
      ...fontRegular,
      color: '#070707',
      fontSize: 16,
      lineHeight: 18,
      letterSpacing: -0.01,
      marginTop: 16,
    },

    textCash: {
      ...fontBold,
      ...textColorCash,
    },

    bodyText: customModalStyles.modalBodyText,

    withdrawalButtonContainer: {
      marginTop: 20,
    },

    cancelButtonContainer: {
      marginTop: 8,
      marginBottom: 18,
    },
  });
};
